// Centralized button motion configuration for consistent animations
export const BASE_BUTTON_MOTION = {
  whileHover: { scale: 1.05, y: -3 },
  whileTap: { scale: 0.95 },
  transition: { duration: 0.1, ease: "easeOut" }
};

// Function to create hover variants with optional overrides and accessibility support
export const hoverVariant = (overrides = {}, reduce = false) => {
  if (reduce === true) {
    return {};
  }

  return {
    ...BASE_BUTTON_MOTION,
    ...overrides,
    whileHover: {
      ...BASE_BUTTON_MOTION.whileHover,
      ...overrides.whileHover
    },
    whileTap: {
      ...BASE_BUTTON_MOTION.whileTap,
      ...overrides.whileTap
    },
    transition: {
      ...BASE_BUTTON_MOTION.transition,
      ...overrides.transition
    }
  };
};